import React from 'react'

import {
  Box,
  Button,
  Typography
} from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'

import { AddBox, Edit } from '@mui/icons-material'

interface AddLPNProps {
  lpn: string
  handleLPNButton: () => void
}

export const AddLPN: React.FC<AddLPNProps> = ({ lpn, handleLPNButton }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Button
        size='large'
        variant='contained'
        color='primary'
        endIcon={lpn ? <Edit /> : <AddBox />}
        onClick={handleLPNButton}
      >
        LPN
      </Button>
      <Box padding={'15px'}>
        <Typography variant='subtitle2' style={{ textAlign: 'center' }}>
          {lpn || 'LPN no registrada'}
        </Typography>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: '10px',
      minHeight: '150px',
      textAlign: 'center'
    }
  })
)
